module.exports = __webpack_public_path__ + "static/media/hangman06.f8db9435.svg";